import request from "@/utils/request";
import { ReFormatQueryStr } from "@/utils/formatquerystr";
class TableData {
    TableDataDel(data){
        return request({
            url: "/bpm/tabledata/del" ,
            method: "post",
            data: data,
          });
    }
  TableDataDownloadUrl(mid, query, fieldlist,ty) {
    var data = {
      page: query.pageNum,
      psize: query.pageSize,
      qstr: {},
      fieldlist: Array.isArray(fieldlist) ? fieldlist.join("|") : fieldlist,
      ty:ty
    };

    var tjson = ReFormatQueryStr(query);
    data.qstr = JSON.stringify(tjson);

    var parata = [];
    for (let i in data) {
      parata.push(i + "=" + data[i]);
    }

    return `/bpm/tabledata/export/${mid}?` + parata.join("&");
  }

  //获取数据表信息
  tableInfo(flowid) {
    return request({
      url: "/bpm/tableinfo/" + flowid,
      method: "get",
    });
  }

  Laobaoqrcodedetail(data) {
    return request({
      url: "/bpm/laobao/qrcodedetail",
      method: "get",
      params: data,
    });
  }

  tableDataList(query, flowid) {
    var data = {
      page: query.pageNum,
      psize: query.pageSize,
      qstr: {},
      flowid: flowid + "",
    };

    var tjson = ReFormatQueryStr(query);
    data.qstr = JSON.stringify(tjson);

    return request({
      url: "/bpm/tabledata/list/" + flowid,
      method: "post",
      data: data,
    });
  }
}

const instance = new TableData();
export default instance;
